import { SalesforceRoleModel } from "@api/types/salesforcerole";
import { httpClient } from "../../httpClient";
type Data = any;

type GetSalesforceRoleResponse = {
  salesforceRoles: SalesforceRoleModel[];
};

const salesforceRoleWebApi = "/api/v1/salesforce/roles/";

export async function getSalesforceRole(): Promise<SalesforceRoleModel[]> {
  try {
    const { data } = await httpClient.get<GetSalesforceRoleResponse>(
      salesforceRoleWebApi
    );
    return data.salesforceRoles;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getSalesforceRoleById(id: number): Promise<any> {
  try {
    const { data } = await httpClient.get(`${salesforceRoleWebApi}${id}`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function postSalesforceRole(
  payload: SalesforceRoleModel
): Promise<any> {
  try {
    const { data } = await httpClient.post<Data>(salesforceRoleWebApi, payload);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function putSalesforceRole(
  id: number,
  payload: SalesforceRoleModel
): Promise<any> {
  try {
    const { data } = await httpClient.put<Data>(
      `${salesforceRoleWebApi}${id}`,
      payload
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export const salesforcerole = {
  getSalesforceRole,
  getSalesforceRoleById,
  postSalesforceRole,
  putSalesforceRole,
};
